import { z } from 'zod';

export const adminAuditUserSchema = z.object({
    id: z.number(),
    displayName: z.string(),
    avatarUrl: z.string().nullable().optional(),
});

export const adminAuditFieldsSchema = z.object({
    created_at: z.string().nullable().optional(),
    updated_at: z.string().nullable().optional(),
    deleted_at: z.string().nullable().optional(),
    created_by: adminAuditUserSchema.nullable().optional(),
    updated_by: adminAuditUserSchema.nullable().optional(),
    deleted_by: adminAuditUserSchema.nullable().optional(),
    last_modified_by: adminAuditUserSchema.nullable().optional(),
    last_modified_at: z.string().nullable().optional(),
});

export type IAdminAuditUser = z.infer<typeof adminAuditUserSchema>;
